import React, { useEffect, useCallback } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, setRedirectPath } = useAuth();
  const location = useLocation();
  const currentPath = location.pathname + location.search;

  // 경로 저장 함수를 메모이제이션
  const saveRedirectPath = useCallback(() => {
    if (!isAuthenticated && !loading) {
      setRedirectPath(currentPath);
    }
  }, [isAuthenticated, loading, currentPath, setRedirectPath]);

  // 인증 상태나 경로가 변경될 때만 실행
  useEffect(() => {
    saveRedirectPath();
  }, [saveRedirectPath]);

  // 로딩 중일 때는 로딩 표시
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>로딩 중...</p>
      </div>
    );
  }

  // 인증되지 않은 사용자는 로그인 페이지로 리다이렉트
  if (!isAuthenticated) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(currentPath)}`} />;
  }

  // 인증된 사용자는 요청한 페이지로 이동
  return children;
};

export default PrivateRoute; 